import React from 'react';
import { Search, Store, ShoppingBag, Truck } from 'lucide-react';

export function HowItWorksImages() {
  const steps = [
    {
      icon: Search,
      title: "Search & Discover",
      description: "Enter your suburb and browse beautiful arrangements from local florists in your area"
    },
    {
      icon: ShoppingBag,
      title: "Select & Order",
      description: "Choose your perfect bouquet, select delivery or pickup, and checkout securely in seconds"
    },
    {
      icon: Truck,
      title: "Fresh Delivery",
      description: "Your florist prepares your order fresh and delivers it right to your door, same day available"
    }
  ];

  return (
    <section className="w-full py-20 bg-neutral-50">
      <div className="max-w-[1440px] mx-auto px-6">
        <div className="text-left mb-16">
          <h2 className="text-4xl md:text-5xl font-semibold text-brand-secondary tracking-tight mb-3 satoshi-font">
            How It Works
          </h2>
          <p className="text-neutral-600 text-[15px] max-w-2xl satoshi-font">
            Simple, secure, and designed around you
          </p>
        </div>

        {/* 3-column layout for steps */}
        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="text-center md:text-left">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-neutral-200 mb-6">
                  <Icon className="w-8 h-8 text-brand-secondary" />
                </div>
                <h3 className="text-xl font-semibold text-brand-secondary mb-3 satoshi-font">
                  {step.title}
                </h3>
                <p className="text-neutral-600 text-[15px] leading-relaxed satoshi-font">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Visual showcase grid */}
        <div className="mt-20 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="relative h-[300px] rounded-lg overflow-hidden group">
            <img 
              src="/images/roses-hero15.jpg" 
              alt="Local florists"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="eager"
              fetchPriority="high"
              style={{
                imageRendering: '-webkit-optimize-contrast',
                WebkitBackfaceVisibility: 'hidden',
                transform: 'translateZ(0)'
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <p className="text-white font-medium satoshi-font">Local Excellence</p>
            </div>
          </div>

          <div className="relative h-[300px] rounded-lg overflow-hidden group">
            <img 
              src="/images/roses-hero14.jpg" 
              alt="Beautiful selection"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="eager"
              fetchPriority="high"
              style={{
                imageRendering: '-webkit-optimize-contrast',
                WebkitBackfaceVisibility: 'hidden',
                transform: 'translateZ(0)'
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <p className="text-white font-medium satoshi-font">Curated Selection</p>
            </div>
          </div>

          <div className="relative h-[300px] rounded-lg overflow-hidden group">
            <img 
              src="/images/roses-hero13.jpg" 
              alt="Secure checkout"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="eager"
              fetchPriority="high"
              style={{
                imageRendering: '-webkit-optimize-contrast',
                WebkitBackfaceVisibility: 'hidden',
                transform: 'translateZ(0)'
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <p className="text-white font-medium satoshi-font">Secure Checkout</p>
            </div>
          </div>

          <div className="relative h-[300px] rounded-lg overflow-hidden group">
            <img 
              src="/images/roses-hero16.jpg" 
              alt="Fresh delivery"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="eager"
              fetchPriority="high"
              style={{
                imageRendering: '-webkit-optimize-contrast',
                WebkitBackfaceVisibility: 'hidden',
                transform: 'translateZ(0)'
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <p className="text-white font-medium satoshi-font">Fresh Delivery</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 